import { connect } from 'react-redux'
import { useParams } from 'react-router-dom'
import DriverDetailsForm from './form'
import {
  create,
  update as updateDriver,
  remove as terminateDriver,
  reset as resetDriverFlags,
  fetchByAgreement as fetchDriver,
  togglePoolVehicle,
  unassignVehicle,
  saveTemporary
} from 'features/drivers/actions'

import {
  resetLookups,
  reset as resetFleetFlags
} from '../../../actions'

import { trimObjectStrings } from 'utils'

/* ---------- Wrapper to inject route param ---------- */

const DriverDetailsContainer = (props) => {
  const { id } = useParams()
  return <ConnectedDriverDetails {...props} routeId={id} />
}

/* ---------- Redux ---------- */

const mapStateToProps = ({ fleet, drivers, settings }, { routeId }) => ({
  driverData: fleet.related,
  fleetData: trimObjectStrings(fleet.data?.[routeId]),
  driverFlags: drivers.flags,
  fleetFlags: fleet.flags,
  fleetIds: settings.fleet.selected,
  driverConfirmationMessage: drivers.apiResponse,
  userRoles: settings.roles
})

const mapDispatchToProps = (dispatch) => ({
  onSaveNewDriver: (payload) => dispatch(create(payload)),
  onUpdateDriver: (uniqueId, payload) =>
    dispatch(updateDriver(payload, { resourceId: uniqueId })),
  onTerminateDriver: (uniqueId) =>
    dispatch(terminateDriver(null, { resourceId: uniqueId })),
  onFetchDriver: (agreementNo, fleetIds) => {
    const FleetId = fleetIds.join(',')
    dispatch(fetchDriver(null, {
      resourceId: agreementNo,
      queryParams: { FleetId }
    }))
  },
  onResetFleetFlags: () => dispatch(resetFleetFlags()),
  onResetDriverFlags: () => dispatch(resetDriverFlags()),
  onTogglePoolVehicle: (agreementNo, fleetId, changeDate, isPoolVehicle) => {
    dispatch(togglePoolVehicle(null, {
      resourceId: `${agreementNo}/${fleetId}/${changeDate.format('YYYY-MM-DD')}/${isPoolVehicle}`
    }))
  },
  onUnassignVehicle: (agreementNo, fleetId) => {
    dispatch(unassignVehicle(null, {
      resourceId: `${agreementNo}/${fleetId}`
    }))
  },
  onResetLookups: () => dispatch(resetLookups()),
  onSaveTemporary: (payload) => dispatch(saveTemporary(payload))
})

const ConnectedDriverDetails = connect(
  mapStateToProps,
  mapDispatchToProps
)(DriverDetailsForm)

export default DriverDetailsContainer
